module.exports = __webpack_public_path__ + "img/sample_she-tai.dd693809.png";